(ns manatee.components.table.formatters
  (:require [clojure.string :as string]
            [garden.color :as colour]
            [goog.string :refer [format]]
            [kee-frame.core :as kf]
            [manatee.admin.task-config.form-components :as task-components]
            [manatee.routing.url :as url]
            [manatee.user.components :as user-components]
            [rothko.theme.manatee.colours :as theme]))

(defn user-field*
  [user-key _ field]
  (let [user (get field user-key)]
    [user-components/full-name user]))

(def user-field (partial user-field* :user))

(def green-tick [:span {:style {:color (colour/as-hex (:green theme/colours))}} "✓"])

(def red-cross [:span {:style {:color (colour/as-hex (:red theme/colours))}} "✗"])

(defn smaller-li
  [key & text]
  ^{:key key} [:li {:style {:font-size :smaller}} (string/join " " text)])

(defn id-field
  [{:keys [id path on-click]}]
  (let [a-element-props (if path
                          {:href (kf/path-for path)}
                          {:href ""
                           :on-click on-click})
        id (str id)
        id-start (subs id 0 3)
        id-end (subs id 33 36)] ; assumes uuid id field
    [:a a-element-props (format "%s...%s" id-start id-end)]))

(defn transform-field
  [k f]
  (fn [_ field]
    (let [target (get field k)]
      (f target))))

(defn smaller-p
  [field-id]
  (fn [_ field]
    [:p {:style {:font-size :smaller}} (field-id field)]))

(defn edit-task-url
  []
  (fn [_ field]
    [:a {:href (url/path-for
                [:manatee.task-config.edit.handlers/edit-task
                 :task-config-id (:task-id field)] {})} (:task-name field)]))

(defn account-source
  []
  (fn [_ field]
    (let [account-key (task-components/data->account-id-key field)]
      [:p {:style {:font-size :smaller}} account-key])))

(defn qa-item-viewed-field
  [viewed-items get-id-keys]
  (fn [_ row]
    (cond
      (some
       (fn [id-key] (when-let [id (id-key row)] (viewed-items (str id))))
       (get-id-keys row))
      green-tick
      :else
      red-cross)))

(defn item-id-handler-selector
  [query-params]
  (fn [_ {:keys [id edits reports]}]
    (let [item-id (str id)
          [latest-report] (sort-by :created reports)
          [latest-edit] (sort-by :created edits)]

      (cond
        (and latest-report
             latest-edit
             (< (:created latest-report) (:created latest-edit)))
        [:a {:href (url/path-for [:manatee.qa.handlers/user-item-edits
                                  :user-id (:user-id latest-edit)
                                  :item-id item-id]
                                 query-params)}
         item-id]
        latest-report [:a {:href (url/path-for
                                  [:manatee.qa.handlers/user-item-reports
                                   :user-id (:user-id latest-report)
                                   :item-id item-id]
                                  query-params)} item-id]
        latest-edit [:a {:href (url/path-for
                                [:manatee.qa.handlers/user-item-edits
                                 :user-id (:user-id latest-edit)
                                 :item-id item-id]
                                query-params)} item-id]
        :else [:a {:href (url/path-for
                          [:manatee.qa.handlers/item
                           :item-id item-id]
                          query-params)} item-id]))))

(defn annotation-state
  []
  (fn [_ {:keys [reports edits] :as _item}]
    (let [[latest-report] (sort-by :created reports)
          [latest-edit] (sort-by :created edits)]
      [:span
       (cond
         (and latest-report latest-edit (< (:created latest-report) (:created latest-edit))) "Edited"
         latest-report "Reported"
         latest-edit "Edited"
         :else "Incomplete")])))

(defn item-group-id
  [user-id query-params]
  (fn [_ {:keys [item-group-id]}]
    [:a {:href (url/path-for
                [:manatee.qa.handlers/item-group
                 :item-group-id item-group-id
                 :user-id user-id]
                query-params)}
     (str item-group-id)]))
